import { AtHeader, AtSetLocationAction } from '@/components/atoms';
import { ESetLocationActionVariants } from '@/components/atoms/at-set-location-action/at-set-location-action.types';
import { IControlHeaderProps } from './types';

export const ControlsHeader = ({
  handleOpen,
  selectedText,
  studioId,
}: IControlHeaderProps) => {
  return (
    <div className="flex flex-col md:mb-12 lg:flex-row lg:justify-between">
      <div className="w-full lg:w-1/2">
        <AtHeader
          className="text-balance text-center md:mb-10 lg:text-left"
          element="h1"
          variant="h2"
        >
          Choose a Plan & Start Customizing
        </AtHeader>
      </div>

      <div className="flex w-full flex-col items-center p-6 md:p-0 lg:w-1/2">
        <AtSetLocationAction
          className="mb-6"
          hasLocation={!!studioId}
          variant={
            studioId
              ? ESetLocationActionVariants.HERO
              : ESetLocationActionVariants.FILTER
          }
          onClick={handleOpen}
        >
          {studioId ? selectedText : null}
        </AtSetLocationAction>

        <AtHeader className="text-skin-tertiary" element="p" variant="h6">
          Your lot location helps us show accurate pricing for your area.
        </AtHeader>
      </div>
    </div>
  );
};
